// Stack routes of the End of day step screens (registered in navigation/AuthenticatedAppStack.js).
// They are opened from End of day only, so they take its tab (driverRoutes.js ROUTE_TAB fallback).
export const END_OF_DAY_ROUTE = {
	MONEY_BAGS: 'MoneyBagsView',
	RETURN_KEYS: 'ReturnKeysView',
	RETURN_STOCK: 'ReturnStockView',
};
